// services/checkUpApi.js
import API from "./interceptor";

// Create new check-up
export const createCheckUp = async (checkUpData) => {
  try {
    const response = await API.post("/api/checkups", checkUpData);
    return response.data;
  } catch (error) {
    console.error("Create checkup error:", error);
    throw error?.response?.data?.message || "Failed to create check-up";
  }
};

// Get check-up by appointment ID
export const getCheckUpByAppointment = async (appointmentId) => {
  try {
    const response = await API.get(
      `/api/checkups/appointment/${appointmentId}`
    );
    return response.data;
  } catch (error) {
    console.error("Get checkup by appointment error:", error);
    // Don't throw error if check-up doesn't exist (404 is expected for new appointments)
    if (error?.response?.status === 404) {
      return { success: false, message: "Check-up not found" };
    }
    throw error?.response?.data?.message || "Failed to fetch check-up";
  }
};

// Get check-ups by pet
export const getCheckUpsByPet = async (petId) => {
  try {
    const response = await API.get(`/api/checkups/pet/${petId}`);
    return response.data;
  } catch (error) {
    console.error("Get checkups by pet error:", error);
    throw error?.response?.data?.message || "Failed to fetch pet check-ups";
  }
};

// Update check-up
export const updateCheckUp = async (checkUpId, updateData) => {
  try {
    console.log("Updating checkup with ID:", checkUpId, "Data:", updateData);
    const response = await API.put(`/api/checkups/${checkUpId}`, updateData);
    return response.data;
  } catch (error) {
    console.error("Update checkup error:", error);
    throw error?.response?.data?.message || "Failed to update check-up";
  }
};

// Get check-ups by doctor
export const getCheckUpsByDoctor = async (doctorId, params = {}) => {
  try {
    const response = await API.get(`/api/checkups/doctor/${doctorId}`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Get checkups by doctor error:", error);
    throw error?.response?.data?.message || "Failed to fetch doctor check-ups";
  }
};

// Get all check-ups with filtering and pagination
export const getAllCheckUp = async (params = {}) => {
  try {
    const response = await API.get("/api/checkups", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Get all checkups error:", error);
    throw error?.response?.data?.message || "Failed to fetch all check-ups";
  }
};
